export enum OPERATOR_COMPARAISON {
    EQUALS = 'EQUALS',
    NOT_EQUALS = 'NOT_EQUALS',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_OR_EQUALS = 'GREATER_OR_EQUALS',
    LOWER_THAN = 'LOWER_THAN',
    LOWER_OR_EQUALS = 'LOWER_OR_EQUALS',
    LIKE = 'LIKE',
    ILIKE = 'ILIKE',
}
